'use client'

import { useState, useEffect } from 'react'

export const useCompaniesCount = () => {
  const [count, setCount] = useState<number>(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await fetch('/api/companies/count')
        if (response.ok) {
          const data = await response.json()
          setCount(data.count || 0)
        }
      } catch (error) {
        console.error('Ошибка загрузки количества компаний:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchCount()
  }, [])

  return { count, loading }
}
